import { useEffect, useState } from "react";
import { apenasNumeros } from "@/services/utils";
import { getArea } from "@/services/ambiente";
import { formataCpfCnpj, validaCpfCnpj } from "@/services/document";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { get } from "@/services/apiParceiro";
import { retornaRotaPagamento } from "@/services/ambiente";
import { useCallback } from "react";
import { useFormik } from "formik";
import { validaNumeroTelefone } from "@/services/utils";
import {
  activeSpinner,
  cancelSpinner,
  setInfoToaster,
  setInfoDialog,
} from "@/store/reducers/geral";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import BotaoPrincipal from "@/components/BotaoPrincipal";
import ShareIcon from "@mui/icons-material/Share";
import * as Yup from "yup";
import Alert from "@mui/material/Alert";
import InputMask from "react-input-mask";
import BotaoText from "@/components/BotaoText";
import InputCpfCnpj from "@/components/InputCpfCnpj";
import InputCep from "@/components/InputCep";
import UFSelect from "@/components/UFSelect";

export default function EtapaConfirmacaoParceiro({
  permiteVoltarEtapa,
  salvarSimulacao,
  salvarSimulacaoParaLink,
  setNavegarEtapa,
  dadosUsuario,
  carregarEtapa,
  abrirLinkPagamento,
  setCarregarEtapa,
}) {
  const dispatch = useDispatch();

  const navigation = useNavigate();

  const [verificaCpfCnpjAoAbrirTela, setVerificaCpfCnpjAoAbrirTela] =
    useState(false);

  const Schema = Yup.object().shape({
    name: Yup.string().nullable().required("Informe os dados"),
    whatsapp: Yup.string()
      .test("len", "Celular inválido", (val) => {
        return (
          apenasNumeros(val).length === 11 &&
          validaNumeroTelefone(apenasNumeros(val))
        );
      })
      .required("Informe seu celular"),
    email: Yup.string().email("E-mail inválido").required("Informe o e-mail"),
    cpfCnpj: Yup.string()
      .required("Informe o CPF ou CNPJ")
      .test("len", "CPF ou CNPJ inválido", (val) => {
        return validaCpfCnpj(val);
      }),
    zipCode: Yup.string()
      .nullable()
      .required("Informe o CEP")
      .test("len", "CEP inválido", (val) => {
        return apenasNumeros(val).length === 8;
      }),
    street: Yup.string().nullable().required("Informe a rua"),
    number: Yup.string().nullable().required("Informe o número"),
    neighborhood: Yup.string().nullable().required("Informe o bairro"),
    city: Yup.string().nullable().required("Informe a cidade"),
    province: Yup.string().nullable().required("Informe o estado"),
  });

  const salvar = async (values, gerarLink) => {
    const tokenFCM = localStorage.getItem("tokenFCM");
    if (tokenFCM) {
      values.tokenFCM = tokenFCM;
    }
    values.name = values.name.trim();
    const posicaoEspaco = (values.name || "").indexOf(" ");
    values.firstName = values.name.substring(0, posicaoEspaco).trim();
    values.lastName = values.name.substring(posicaoEspaco, 9999).trim();
    values.whatsapp = apenasNumeros(values.whatsapp);
    values.cep = apenasNumeros(values.cep);
    values.cpf = apenasNumeros(values.cpf);
    values.cnpj = apenasNumeros(values.cnpj);
    if (gerarLink) {
      return await salvarSimulacaoParaLink(values);
    }
    return await salvarSimulacao(values);
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      whatsapp: "",
      province: "",
      howDidYouGetUs: "",
      zipCode: "",
      street: "",
      number: "",
      complement: "",
      neighborhood: "",
      city: "",
      name: "",
      personType: "",
      cpfCnpj: "",
    },
    validationSchema: Schema,
    onSubmit: async (values) => {
      values.name = values.name.trim();

      if (values.personType === "PF" && values.name.indexOf(" ") === -1) {
        dispatch(
          setInfoDialog({
            open: true,
            descricao: "Informe o nome completo com nome e sobrenome!",
          })
        );
        return;
      }

      const requestResult = await salvar(values);
      navigation(retornaRotaPagamento(requestResult));
    },
  });

  const handleChangeCpfCnpj = useCallback(
    async (valor) => {
      const cpfCnpjFormatado = formataCpfCnpj(valor);
      formik.setFieldValue("cpfCnpj", cpfCnpjFormatado);

      const cpfCnpj = apenasNumeros(valor);
      const cpfCnpjValido = validaCpfCnpj(cpfCnpj);
      if (cpfCnpj.length === 11) {
        formik.setFieldValue("cpf", valor);
        formik.setFieldValue("personType", "PF");
      } else {
        formik.setFieldValue("cnpj", valor);
        formik.setFieldValue("personType", "PJ");
      }
      if (getArea() !== "parceiro" || !cpfCnpjValido) {
        return;
      }

      dispatch(activeSpinner());
      try {
        const result = await get(
          `secure/user/verify-client-register/${cpfCnpj}`
        );
        dispatch(cancelSpinner());

        if (!!result) {
          formik.setValues({
            ...formik.values,
            cpfCnpj: cpfCnpjFormatado,
            cpf: result.cpf,
            cnpj: result.cnpj,
            email: result.email,
            whatsapp: result.whatsapp,
            province: result.province,
            zipCode: result.zipCode,
            street: result.street,
            number: result.number,
            complement: result.complement,
            neighborhood: result.neighborhood,
            city: result.city,
            name: result.name,
            personType: result.personType,
          });
          dispatch(
            setInfoToaster({
              open: true,
              message:
                "Usuário já cadastrado. Os dados foram preenchidos automáticamente.",
              type: "success",
            })
          );
        }
      } catch (e) {
        console.log(e);
        dispatch(cancelSpinner());
      }
    },
    [dispatch, formik]
  );

  const camposInvalidos = () => {
    return Object.values(formik.errors).length > 0 && formik.submitCount > 0;
  };

  useEffect(() => {
    if (!verificaCpfCnpjAoAbrirTela) {
      return;
    }
    setVerificaCpfCnpjAoAbrirTela(false);
    handleChangeCpfCnpj(formik.values.cpfCnpj);
  }, [
    formik,
    verificaCpfCnpjAoAbrirTela,
    setVerificaCpfCnpjAoAbrirTela,
    handleChangeCpfCnpj,
  ]);

  useEffect(() => {
    if (!carregarEtapa) {
      return;
    }
    setCarregarEtapa(false);
    const cpfCnpj = dadosUsuario.cpf || dadosUsuario.cnpj;
    dadosUsuario.cpfCnpj = cpfCnpj;
    formik.setValues(dadosUsuario);
    if (cpfCnpj) {
      setVerificaCpfCnpjAoAbrirTela(true);
    }
  }, [
    formik,
    carregarEtapa,
    setCarregarEtapa,
    handleChangeCpfCnpj,
    dadosUsuario,
  ]);

  const criarLink = async () => {
    const requestResult = await salvar(formik.values, true);
    abrirLinkPagamento(requestResult);
  };

  const voltar = () => {
    if (dadosUsuario.useNewSimulator) {
      setNavegarEtapa(2);
      return;
    }
    if (dadosUsuario?.infoPartner?.informedRequestBills) {
      if (dadosUsuario?.infoPartner?.installments) {
        setNavegarEtapa(1);
        return;
      }
      setNavegarEtapa(2);
      return;
    }
    setNavegarEtapa(3);
  };

  return (
    <>
      <Typography align="center">
        Precisamos de mais alguns dados para finalizar a contratação:
      </Typography>

      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item size={{ xs: 12, md: 6 }}>
            <InputCpfCnpj {...{ formik }} />
          </Grid>
          <Grid item size={{ xs: 12, md: 6 }}>
            <InputMask
              mask="(99) 9 9999-9999"
              value={formik.values.whatsapp}
              name="whatsapp"
              onChange={formik.handleChange}>
              {() => (
                <TextField
                  id="whatsapp"
                  name="whatsapp"
                  label="Telefone/WhatsApp *"
                  fullWidth
                  autoComplete="tel"
                  variant="outlined"
                  error={
                    formik.touched.whatsapp && Boolean(formik.errors.whatsapp)
                  }
                  helperText={formik.touched.whatsapp && formik.errors.whatsapp}
                />
              )}
            </InputMask>
          </Grid>
          <Grid item size={12}>
            <TextField
              name="name"
              label={
                formik.values.personType === "PJ"
                  ? "Razão social *"
                  : "Nome completo *"
              }
              fullWidth
              autoComplete="given-name"
              variant="outlined"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <TextField
              id="email"
              name="email"
              label="E-mail *"
              fullWidth
              autoComplete="email"
              variant="outlined"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          </Grid>

          <Grid item size={12}>
            <InputCep {...{ formik }} />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <TextField
              id="street"
              name="street"
              label={"Rua *"}
              fullWidth
              variant="outlined"
              value={formik.values.street}
              onChange={formik.handleChange}
              error={formik.touched.street && Boolean(formik.errors.street)}
              helperText={formik.touched.street && formik.errors.street}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <TextField
              id="number"
              name="number"
              label={"Número *"}
              fullWidth
              variant="outlined"
              value={formik.values.number}
              onChange={formik.handleChange}
              error={formik.touched.number && Boolean(formik.errors.number)}
              helperText={formik.touched.number && formik.errors.number}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <TextField
              id="complement"
              name="complement"
              label="Complemento"
              fullWidth
              variant="outlined"
              value={formik.values.complement}
              onChange={formik.handleChange}
            />
          </Grid>

          <Grid item size={{ xs: 12, sm: 6 }}>
            <TextField
              id="neighborhood"
              name="neighborhood"
              label={"Bairro *"}
              fullWidth
              variant="outlined"
              value={formik.values.neighborhood}
              onChange={formik.handleChange}
              error={
                formik.touched.neighborhood &&
                Boolean(formik.errors.neighborhood)
              }
              helperText={
                formik.touched.neighborhood && formik.errors.neighborhood
              }
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <TextField
              id="city"
              name="city"
              label={"Cidade *"}
              fullWidth
              variant="outlined"
              value={formik.values.city}
              onChange={formik.handleChange}
              error={formik.touched.city && Boolean(formik.errors.city)}
              helperText={formik.touched.city && formik.errors.city}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <UFSelect {...{ formik }} />
          </Grid>

          {camposInvalidos() && (
            <Grid item size={12}>
              <Alert severity="warning">
                <Typography>
                  Verifique se os campos obrigatórios foram preenchidos
                  corretamente!
                </Typography>
              </Alert>
            </Grid>
          )}
        </Grid>

        <Grid container spacing={3}>
          <Grid item size={6}>
            {permiteVoltarEtapa() && (
              <Box>
                <Button
                  onClick={() => {
                    voltar();
                  }}
                  sx={{ mt: 3, ml: 1 }}>
                  VOLTAR
                </Button>
              </Box>
            )}
          </Grid>
          <Grid item size={6}>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <BotaoPrincipal
                id="btn-avancar-confirmacao-dados"
                type="submit"
                sx={{ mt: 3, ml: 1 }}>
                IR PARA PAGAMENTO
              </BotaoPrincipal>
            </Box>
          </Grid>
          {!dadosUsuario.useNewSimulator && (
            <Grid item size={12} align="center">
              <BotaoText
                type="button"
                startIcon={<ShareIcon />}
                onClick={() => {
                  criarLink();
                }}>
                COMPARTILHAR
              </BotaoText>
            </Grid>
          )}
        </Grid>
      </form>
    </>
  );
}
